/**
 * Admin Summary Trends Routes
 * legacy app: canActivate: [AuthGuard, VendorRoleGuard]
 */

import { lazy } from 'react';
import { RouteConfig } from '../../types';

const DigitalSummary = lazy(() =>
  import('@src/apps/DigitalSummary/DigitalSummary').then(m => ({ default: m.DigitalSummary }))
);

export const adminSummaryTrendsRoutes: RouteConfig[] = [
  {
    path: 'AdminSummaryTrends/*',
    component: DigitalSummary,
    guards: ['auth', 'vendor'],
    data: {
      title: 'Admin Summary Trends',
      breadcrumb: 'Admin Summary Trends',
      preload: true,
      delay: false,
    },
  },
];

